import {LANGUAGE_CODE_TO_COUNTRY_CODE, LanguageCodeType} from '../../../service/language/language-const';

import {flagIcons} from './flag-const';

export function getFlag(value: LanguageCodeType): string | null {
    const countryCode = LANGUAGE_CODE_TO_COUNTRY_CODE[value.toLowerCase() as LanguageCodeType];

    return countryCode ? flagIcons[countryCode] : null;
}
